import { FoundationElement } from '@microsoft/fast-foundation';
import { repeat, css, customElement, html, observable, when } from '@genesislcap/web-core';
import { MaturityOrder } from '../deal-series/deal-series.types';
import { getConditionsSummaryForGrid } from '../deal-series/deal-series.util';

export interface Condition {
  iconText?: string;
  iconName?: string;
  iconUrl?: string;
  iconColor?: string;
  text?: string;
  iconBackgroundColor?: string;
}

@customElement({
  name: 'deal-conditions-summary',
  template: html<DealConditionsSummary>`
    <div class="deal-conditions">
      ${repeat(
        (x) => x.conditions,
        html<Condition>`
          <div class="deal-conditions-item">
            ${when(
              (x) => x.iconName,
              html<Condition>`
                <rapid-icon name="${(x) => x.iconName}"></rapid-icon>
              `,
            )}
            ${when(
              (x) => x.iconUrl,
              html<Condition>`
                  <img alt="${(x) => x.iconText}" class="image-icon" src="${(x) => x.iconUrl}"></img>
              `,
            )}
            ${when(
              (x) => x.iconText,
              html<Condition>`
                <div
                  class="deal-conditions-item-icon"
                  style="color:${(x) => x.iconColor}; background-color: ${(x) =>
                    x.iconBackgroundColor}"
                >
                  ${(x) => x.iconText}
                </div>
              `,
            )}
            ${(x) => x.text}
          </div>
        `,
      )}
    </div>
  `,
  styles: css`
    :host {
      height: 100%;
      width: 100%;
    }

    .deal-conditions {
      display: flex;
      height: 100%;
      width: 100%;
      gap: 8px;
      align-items: center;

      .deal-conditions-item {
        display: flex;
        gap: 4px;
        align-items: center;
      }

      .deal-conditions-item-icon {
        height: 14px;
        width: 14px;
        border-radius: 7px;
        font-weight: bold;
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .image-icon {
        height: 14px;
      }
    }
  `,
})
export class DealConditionsSummary extends FoundationElement {
  @observable order: MaturityOrder;

  @observable conditions: Condition[];

  orderChanged(_oldValue: MaturityOrder, newValue: MaturityOrder): void {
    this.conditions = getConditionsSummaryForGrid(newValue);
  }
}
